export const MONTH_OPTIONS = ["Dec'25", "Feb'26"];

export const DEFAULT_MONTH = "Dec'25";

export const VALID_MONTHS = new Set(MONTH_OPTIONS);

export const PERIOD_LABELS = {
  "Dec'25": 'December 2025',
  "Feb'26": 'February 2026',
};

export function resolveMonth(value) {
  return VALID_MONTHS.has(value) ? value : DEFAULT_MONTH;
}
